import {ActionIcon, Avatar, Group, Paper, Text} from '@mantine/core'
import {IconMinus, IconTruck} from '@tabler/icons-react'

import {actionDestructiveColor, identityEquipmentColor} from 'src/theme/semantic-colors'

import {formatGroupedEquipmentName} from './stock-equipment'

type GroupedEquipmentAssignmentCardProps = {
    resourceName: string
    quantity: number
    supplierName?: string
    disabled?: boolean
    onRemove?: () => void
    testId?: string
}

export function GroupedEquipmentAssignmentCard({
    resourceName,
    quantity,
    supplierName,
    disabled = false,
    onRemove,
    testId,
}: GroupedEquipmentAssignmentCardProps) {
    const displayName = formatGroupedEquipmentName(resourceName, quantity)

    return (
        <Paper withBorder p="sm" radius="md" data-testid={testId}>
            <Group justify="space-between" wrap="nowrap" align="center">
                <Group gap="sm" wrap="nowrap" style={{minWidth: 0, flex: 1}}>
                    <Avatar radius="xl" size="sm" color={identityEquipmentColor()}>
                        <IconTruck size={14} />
                    </Avatar>
                    <Text size="sm" fw={600} lineClamp={2} title={displayName}>
                        {displayName}
                        {supplierName ? ' · ' + supplierName : ''}
                    </Text>
                </Group>

                {onRemove ? (
                    <ActionIcon
                        variant="subtle"
                        color={actionDestructiveColor()}
                        size="sm"
                        aria-label="Remove"
                        disabled={disabled}
                        onClick={onRemove}
                    >
                        <IconMinus size={14} />
                    </ActionIcon>
                ) : null}
            </Group>
        </Paper>
    )
}
